if (!customElements.get('carousel-slider')) {
	class CarouselSlider extends HTMLElement {
		constructor() {
			super();

			const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

			if (Shopify.designMode) {
				window.addEventListener('shopify:section:load', e => {
					const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

					this.reInitSlider(swiperOptions);
				});
			}

			this.initSlider(swiperOptions);
		}

		reInitSlider(swiperOptions) {
			// Destroy the existing Swiper instance
			if (this.slider) {
				this.slider.destroy();
			}

			// Re-initialize the slider with the new options
			this.initSlider(swiperOptions);
		}

		playPromise(video) {
			let playPromise = video.play();
			if (playPromise !== undefined) {
				playPromise
					.then(() => {
						// Automatic playback started!
						// Show playing UI.
						// video.play();
					})
					.catch(error => {
						// Auto-play was prevented
						// Show paused UI.
						video.pause();
					});
			}
		}

		initSlider(swiperOptions) {

			let sliderOptions = {
				slidesPerView: 'auto',
				spaceBetween: swiperOptions.spaceBetweenMobile || 0,
				autoplay: {
					delay: swiperOptions.autoplayDelay || 5000,
					disableOnInteraction: false,
					pauseOnMouseEnter: true,
				},
				loop: true,
				resistanceRatio: 0.72,
				navigation: {
					nextEl: '.swiper-button--next',
					prevEl: '.swiper-button--prev',
				},
				breakpoints: {
					750: {
						slidesPerView: swiperOptions.slidesPerViewDesktop || 3,
						spaceBetween: swiperOptions.spaceBetweenDesktop || 0,
					}
				},
				on: {
					afterInit: swiper => {
						// console.log('swiper initialized');
					},
					transitionStart: swiper => {
						// console.log('swiper transition start');

						const videos = swiper.el.querySelectorAll('video');

						// pause all videos except first one
						videos.forEach((video, index) => {
							if (index !== 0) {
								video.pause();
							}
						});
					},
					transitionEnd: swiper => {
						const activeSlide = Array.from(swiper.slides).find(
							sliderSlide =>
								sliderSlide.classList.contains(
									'swiper-slide-active'
								)
						);
						const activeSlideVideo = activeSlide?.querySelector('video');
						// if active slide is video, stop autoplay and play video
						if (activeSlideVideo) {
							// swiper.autoplay.stop();

							const playVideo = video => {
								if (video && video.paused) {
									this.playPromise(video);
								} else if (video) {
									video.pause();
								}
							};

							playVideo(activeSlideVideo);

							/*
							// listen ended event
							activeSlideVideo.addEventListener('ended', () => {
								swiper.autoplay.start();
								swiper.slideNext(); // Move to the next slide
							});
							*/
						}
					}
				}
			};

			this.slider = new Swiper(this, sliderOptions);
		}
	}

	customElements.define('carousel-slider', CarouselSlider);
}